import React from 'react';
import styled from 'styled-components';
import Icon from '../../CommonComponents/Icon';

const getPeriodString = (periodId) => {
  switch (periodId) {
    case 4:
      return 'the month-to-date';
    case 3:
      return 'the year-to-date';
    case 2:
      return 'the past 1 year';
    case 1:
      return 'the past 90 days';
    case 0:
      return 'the past 30 days';
    default:
      return 'any period';
  }
};

const getAccountString = account => (account ? account.accountName : 'all accounts');

const Wrapper = styled.div`
  padding: 40px;
  text-align: center;
`;

const BriefcaseIcon = styled(Icon).attrs({
  className: 'fa fa-briefcase',
})`
  color: #8F959F;
  font-size: 84px;
  display: block;
  text-shadow: #fff 1px 1px 0;
`;

const Message = styled.p`
  font-size: 20px;
  color: #6C727F;
  text-shadow: #fff 1px 1px 0;
  margin: 20px 0 30px 0;
`;

export default ({ currentPeriodId, currentAccount }) => (
  <Wrapper>
    <BriefcaseIcon />
    <Message>
      There are no transactions available for {getPeriodString(currentPeriodId)} on{' '}
      {getAccountString(currentAccount)}.
    </Message>
  </Wrapper>
);
